import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Redirect} from 'react-router-dom';
import qs from 'qs';
import {requestCreateSurveyInstance, requestCreateTrackedSurveyInstance, requestSurvey, requestTrackedSurvey} from '../actions/action_survey';
import SubmitButton from './SubmitButton';
import Layout from './Layout';
import messages from '../../res/translations/messages';
import {Helmet} from 'react-helmet-async';
import {constants} from '@neosvoc/nv-platform-core-common';

class Survey extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.trackerCode) {
            this.props.requestTrackedSurvey(this.props.match.params.trackerCode);
        } else {
            this.props.requestSurvey(this.props.match.params.id);
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        const extra = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
        if (this.props.match.params.trackerCode) {
            this.props.requestCreateTrackedSurveyInstance(this.props.match.params.trackerCode, extra);
        } else {
            this.props.requestCreateSurveyInstance(this.props.match.params.id, extra);
        }
    }

    render() {
        const {currentInstanceId, error, survey} = this.props;

        if (currentInstanceId) {
            return <Redirect to={`/instance/${currentInstanceId}`} />;
        }
        if (error) {
            /* return (
                <div className="alert alert-danger">An error occurred: {error}.</div>
            ); */

            return (<Layout className="start">
                <div className="start-page text-center">
                    {error.response.data.code === constants.SERVER_ERRORS.VALIDATION ?
                        <FormattedMessage {...messages.survey.invalid} />:
                        <FormattedMessage {...messages.survey.unavailable} />
                    }
                </div>
            </Layout>);
        }
        if (!survey) {
            return null; // TODO: show loader
        }
        const lang = survey.locale.substring(0, 2);
        const description = (survey.intro || '').replace(/(<([^>]+)>)/ig, '').replace(/(\r\n|\r|\n)+/g, ' ');
        const image = (survey.branding && survey.branding.logo || null);

        if (survey.instanceId) {
            // Tracked surveys already started
            return <Redirect to={`/instance/${survey.instanceId}`} />;
        }
        return (
            <>
                <Helmet>
                    <html lang={lang} />
                    {description !== '' && <meta name="description" content={description} />}

                    <meta property="og:title" content={survey.name} />
                    <meta property="og:type" content="article" />
                    {image && <meta property="og:image" content={image} />}
                    {description !== '' && <meta property="og:description" content={description} />}

                    <meta name="twitter:card" content="summary" />
                    <meta name="twitter:title" content={survey.name} />
                    {description !== '' && <meta name="twitter:description" content={description} />}
                    {image && <meta name="twitter:image" content={image} />}
                    <title>{survey.name}</title>
                </Helmet>
                <Layout className="start" branding={survey && survey.branding}>
                    <div className="col-md-10 align-self-center start-page">
                        {survey && <h1>{survey.name}</h1>}
                        {(survey && survey.intro && description.length > 0) ?
                            <p dangerouslySetInnerHTML={{__html: survey.intro}} /> :
                            <FormattedMessage {...messages.survey.start_message} />}
                    </div>
                    <div className="col-md-2 offset-md-10 buttons-bar">
                        <form onSubmit={this.handleSubmit}>
                            <SubmitButton>
                                <FormattedMessage {...messages.survey.start_button} />
                            </SubmitButton>
                        </form>
                    </div>
                </Layout>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    currentInstanceId: state.survey.instanceId,
    error: state.survey.error,
    survey: state.survey.item,
});

export default connect(mapStateToProps, {requestCreateSurveyInstance, requestCreateTrackedSurveyInstance, requestSurvey, requestTrackedSurvey})(Survey);
